/// <reference path="../services/datacontext.js" />
// app/tirocinante/aziende.js

(function () {
	'use strict';
    var controllerId = 'curriculumVitae';
	angular.module('app').controller(controllerId, ['$scope', 'common', '$rootScope', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', curriculumVitae]);

	function curriculumVitae($scope, common, $rootScope, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var logError = getLogFn(controllerId, 'logError');
		var logSuccess = getLogFn(controllerId, 'logSuccess');


		var vm = this;
        vm.title = 'Curriculum Vitae';
        vm.view = 'detail';       //Opzione list or detail
		vm.setView = setView;
		vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "curriculumVitae"; //Utilizzato per pannello authorization		
		vm.authorization = {};
		vm.showObjPanel = false;
		vm.record = {};
		vm.records = [];
		vm.countRecords = 0;
		vm.index = 0;
		vm.custom = false;

        vm.addDisabled = false;
		vm.exportDisabled = false;
		vm.pageSize = 30;
		vm.page = 1;
        vm.loading = false;

        vm.cndProgetto = {};
        vm.showDivs = {};
        vm.showDivs.ableToAccess = false;
        vm.showDivs.callExpired = false;
        vm.showDivs.linkError = true;
        

		//Elenco per Ordinamento
		vm.list = {};
		vm.list.ordine = ['Nominativo', 'Codice Fiscale'];
		vm.ordine = vm.list.ordine[0];
		vm.selectOrdine = function (item) {
			vm.ordine = item;
		};

		//Elenchi dettaglio
		vm.list.attach = [];
		vm.list.b_attach = false;
		

		vm.getRecord = getRecord;
		//vm.getAuthorization = getAuthorization;
		vm.getListAttach = getListAttach;
		vm.disableCompleted = true;

		//Conteggio Elenchi
		vm.countAttachProfilo = function () {
			var filter = {};
			return filterFilter(vm.list.attach, filter).length;
        }

        vm.saveAll = saveAll;

        //CND CV
        vm.currVitae = {};
        vm.addCV = addCV;
        vm.updateCV = updateCV;

        //CNDCV_Spec
        vm.cv_spec = {};
        vm.list.cv_specs = [];
        vm.addSpec = addSpec;
        vm.deleteSpec = deleteSpec;
        

        //CNDCV_Servizio
        vm.cv_servizio = {};
        vm.list.cv_servizi = [];
        vm.addServizio = addServizio;
        vm.deleteServizio = deleteServizio;


		//Filtro
		vm.fNominativo = '';
        vm.fDomandaAdesioneId = -1;

		vm.filter = {};
        vm.filter.nominativo = vm.fNominativo;
        vm.filter.domandaAdesioneId = vm.fDomandaAdesioneId;

		vm.fAttach = {};

		//Elenchi per filtri e finestra modale di Create
        vm.cmblist = {};
        vm.cmblist.titoliStudio = [];
		vm.cmblist.mesi = datacontext.arrMesi();

        vm.tSource = {};
        vm.tAttach = [];


		//Metodi su interfaccia
		vm.cerca = cerca;
		vm.activated = false;
		vm.loadMore = getAllByFilter;
		vm.loadAll = getAll;

		vm.goNext = goNext;
		vm.goPrev = goPrev;

		vm.addAttach = addAttach;
		vm.deleteAttach = deleteAttach;
		vm.setCompleted = setCompleted;

		vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
		vm.delete = deleteItem;
        
	    
		//datapicker
		vm.open = function ($event, iOpened) {
			$event.preventDefault();
			$event.stopPropagation();

			vm.opened1 = false;
			if (iOpened == 1)
				vm.opened1 = true;
		};

		vm.clear = function ($event, iOpened) {
			if (iOpened == 1) {
				vm.record.NascData = '';
				vm.changed = true;
			}
		};

		vm.dateOptions = {
			formatYear: 'yyyy',
			formatMonth: 'MM',
			startingDay: 1
		};

		vm.format = 'dd/MM/yyyy';

		// ---- ACTIVATE -------
		activate();

		function activate() {
            var promises = [getTSource('CV'), getTAttach('CV'), getTitoliStudio()];
			common.activateController(promises, controllerId)
							.then(function () {
                                vm.disableTornaIndietro = true;
                                
                                //$routeParams.projectUID = 'b18ded25-a2ae-4946-8e70-db8d53b8fcbe';
                                //$routeParams.accreditamentoUID = 'd2d835a2-f101-4208-a292-df5cad32bbac';
                                if ($routeParams.projectUID != null) {
                                    getCNDProgetto($routeParams.projectUID);
                                }

                                if ($routeParams.domandaAdesioneUID != null) {
                                    vm.Uid = $routeParams.domandaAdesioneUID;
                                    getCV(vm.Uid);
                                    getRecordByUID(vm.Uid);
                                }
                                
                                if ($routeParams.domandaAdesioneId != null) {
                                    vm.domandaAdesioneId = $routeParams.domandaAdesioneId;
                                    
                                    getAllSpec(vm.domandaAdesioneId);
                                    getAllServizio(vm.domandaAdesioneId);
                                }          
                                
                                //*****************
                                //Messo a scopo DEBUG
                                /*
                                vm.domandaAdesioneId = 1;
                                vm.Uid = 'd2d835a2-f101-4208-a292-df5cad32bbac';
                                getCV(vm.Uid);
                                getAllSpec(vm.domandaAdesioneId);
                                getAllServizio(vm.domandaAdesioneId);
                                */
                                //******************
                                
								
								getAuthorization();
								vm.sectionMenu = sectionMenu.setSection(vm.title);
								vm.activated = true;
                                cerca();
                                //getAllByFilter();

							});
		}


		//****************************************************
		// METODI 
		//****************************************************
		function setView(view) {
			return vm.view = view;
		}

		function cerca() {
			vm.records = [];
			vm.countRecords = 0;
			vm.page = 1;

            vm.filter.nominativo = vm.fNominativo == null ? '' : vm.fNominativo;
            vm.filter.domandaAdesioneId = vm.fDomandaAdesioneId == null ? -1 : vm.fDomandaAdesioneId;

			vm.loading = false;

			return getAllByFilter();
		}

		function countByFilter() {
		    var az1 = (vm.filter.azId == 1);
		    var az2 = (vm.filter.azId == 2);
		    var az3 = (vm.filter.azId == 3);
		    var az4 = (vm.filter.azId == 4);
            return datacontext.cndCV_countAll(vm.filter.domandaAdesioneId, vm.filter.nominativo)
					.then(function (data) {
						if (data) {
							vm.countRecords = data;
						}
					});
		}

		function getAllByFilter() {
			if (!vm.activated) return;
			if (vm.loading === true) return;

			if (vm.countRecords == 0) countByFilter();
			else if (vm.countRecords <= vm.records.length) return;

			vm.loading = true;

            return datacontext.cndCV_getAll(vm.pageSize, vm.page, vm.filter.domandaAdesioneId, vm.filter.nominativo, vm.ordine)
					.then(function (data) {
						if (data.constructor === Array) {
							vm.page++;
							data.forEach(function (item) {
								vm.records.push(item);
							});
						}
						vm.loading = false;
					});
		}

		function getAll() {
			if (vm.records.length < vm.countRecords) {
				getAllByFilter().then(function () { getAll(); });
			}
		}

		function getAuthorization() {
			return $rootScope.getAuthorization(vm, vm.objName).then(function (data) {
				//
			});
		}


        function getCNDProgetto(cndProgettoUID) {
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    //Codice Progetto errato
                    if (data.UID != cndProgettoUID) {
                        vm.cndProgetto = {};
                        vm.showDivs.linkError = true;
                        vm.showDivs.callExpired = false;
                        vm.showDivs.ableToAccess = false;
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;

                        var dt = new Date();
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.showDivs.linkError = false;
                        vm.showDivs.callExpired = (dt < dtStart || dt > dtEnd);
                        vm.showDivs.ableToAccess = !vm.showDivs.callExpired;

                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                    }

                },
                //else
                function (data) {
                    vm.cndProgetto = {};
                    vm.showDivs.linkError = true;
                    vm.showDivs.callExpired = false;
                    vm.showDivs.ableToAccess = false;
                }
                );
        }

		function setCompleted() {
			if (!vm.record.Completed)
				bDialog.confirmationDialog('Attenzione', 'Impostando una azienda come \'TRASMESSA\' non sar\xE0 possibile apportare modifiche successivamente.', 'OK').then(
					function () { //YES
						vm.record.Completed = true;
						vm.update();
						//updateGUI();
					},
					function () { //NO
						//vm.record.Completed = false;
					}
				);
		}

		function getRecord(id, index) {
            return datacontext.cndCV_getByDomandaUID(id).then(function (data) {
				vm.index = index;
                vm.record = data;                
                
                //Azzera liste
                vm.list.attach = [];
				vm.list.b_attach = false;
                
				setView('detail');
			});
        }


        function getRecordByUID(uid) {
            return datacontext.cndCV_getByDomandaUID(uid).then(function (data) {
                vm.record = data;

                //Azzera liste
                vm.list.attach = [];
                vm.list.b_attach = false;

                vm.linkAdesione = "#/CNDDomanda/" + vm.cndProgetto.UID + "/" + vm.record.UID;
                //vm.linkCV = "#/CNDCV/" + vm.cndProgetto.UID + "/" + vm.record.UID;

                setView('detail');
            });
        }

		function goNext() {
			if (vm.index + 1 >= vm.countRecords) return;
			if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
				getByFilter();
			}
			if (!vm.records) return;

			vm.index++;
			return getRecord(vm.records[vm.index].Id, vm.index);
		}

		function goPrev() {
			if (vm.index == 0) return;
			if (!vm.records) return;

			vm.index--;

			return getRecord(vm.records[vm.index].Id, vm.index);
		}


		function addRecord(id) {
			return datacontext.cndCV_get(id).then(function (data) {
				vm.records.push(data);
				vm.countRecords++;
			});
        }

        function updateItem() {
            return datacontext.cndCV_update(vm.record).then(function (data) {
                if (data == "400") return logError('Errore: inserimento non riuscito. ');
                if (data == "409") return logError('Errore: tentativo di duplicazione. ');

                //vm.records[vm.index] = data;
                logSuccess('Record Salvato ');
            });		
        }

		function deleteItem(item) {
			//console.dir(item);
			var msg = ' il curriculum vitae di : ' + item.DoamndaAdesione;
			bDialog.deleteDialog(msg).then(function () {
				return datacontext.cndCV_delete(item.Id).then(function (data) {
					if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

					var index = vm.records.indexOf(item)
					vm.records.splice(index, 1);
					vm.countRecords--;
				});
			});
		}

		//List Methods
		function getListAttach(id) {
			if (!id) return;

			return datacontext.attach_getAll(0, 0, 'CV', 0, id, vm.fAttach.TAttachId, 0, '').then(function (data) {
				vm.list.b_attach = true;
				return vm.list.attach = data;
			});
        }


        function saveAll() {
            saveAllSpec();
            saveAllServizio();
            saveCV();
        }

        //****************************
        // CND CV

        function getCV(Uid) {
            return datacontext.cndCV_getByDomandaUID(Uid).then(function (data) {
                return vm.currVitae = data;
            });
        }

        function saveCV() {
            if (vm.currVitae == null || vm.currVitae.Id == 0)
                addCV();
            else
                updateCV();
        }

        function addCV() {
            vm.currVitae.DoamndaAdesioneId = vm.domandaAdesioneId;
            return datacontext.cndCV_add(vm.currVitae).then(function (data) {
                if (data == "400") return logError('Errore: inserimento non riuscito. ');

                return logSuccess('Record Salvato ');
            });
        }

        function updateCV() {
            return datacontext.cndCV_update(vm.currVitae).then(function (data) {
                if (data == "400") return logError('Errore: inserimento non riuscito. ');
                if (data == "409") return logError('Errore: tentativo di duplicazione. ');

                //vm.records[vm.index] = data;
                logSuccess('Record Salvato ');
            });
        }
        
        //****************************
        // CNDCV_Spec

        function getAllSpec(domandaAdesioneId) {
            return datacontext.cndCVSpec_getAll(0, 0, domandaAdesioneId, -1, -1, -1, -1, 'IDDomanda').then(function (data) {
                return vm.list.cv_specs = data;
            });
        }

        function addSpec() {
            if (vm.cv_spec.Titolo == null || vm.cv_spec.Ente == null || vm.cv_spec.Mese == null || vm.cv_spec.Anno == null)
                return log('Riempi i campi della seconda scheda');

            vm.cv_spec.domandaAdesioneId = vm.domandaAdesioneId;
            
            vm.list.cv_specs.push(vm.cv_spec);

            vm.cv_spec = {};            
        }

        function deleteSpec(item) {
            if (item.Id > 0) {
                datacontext.cndCVSpec_delete(item.Id).then(function (data) { });
            }

            var index = vm.list.cv_specs.indexOf(item)
            vm.list.cv_specs.splice(index, 1);
        }

        function saveAllSpec() {
            if (vm.list.cv_specs.length > 0) {
                var items = vm.list.cv_specs;

                return datacontext.cndCVSpec_saveAll(items).then(function (data) {
                    if (data == "404") return logError('Errore sul salvataggio. ');

                    return;//logSuccess('Record Salvati. ');
                });
            }            
        }

        //****************************
        // CNDCV_Servizio

        function getAllServizio(domandaAdesioneId) {
            return datacontext.cndCVServizio_getAll(0, 0, domandaAdesioneId, -1, -1, -1, -1, 'IDDomanda').then(function (data) {
                return vm.list.cv_servizi = data;
            });
        }

        function addServizio() {
            if (vm.cv_servizio.Ente == null)
                return log('Riempi i campi della terza scheda');

            vm.cv_servizio.domandaAdesioneId = vm.domandaAdesioneId;

            vm.list.cv_servizi.push(vm.cv_servizio);

            vm.cv_servizio = {};
        }

        function deleteServizio(item) {
            if (item.Id > 0) {
                datacontext.cndCVServizio_delete(item.Id).then(function (data) { });
            }

            var index = vm.list.cv_servizi.indexOf(item)
            vm.list.cv_servizi.splice(index, 1);
        }

        function saveAllServizio() {
            if (vm.list.cv_servizi.length > 0) {
                var items = vm.list.cv_servizi;

                return datacontext.cndCVServizio_saveAll(items).then(function (data) {
                    if (data == "404") return logError('Errore sul salvataggio. ');

                    return;//logSuccess('Record Salvati. ');
                });
            }
        }

        //************************END*****************************

		//Elenchi Parametri
		function getTSource(code) {
			if (!code) return;

			return datacontext.tSource_getByCode(code).then(function (data) {
				return vm.tSource = data;
			});
		}

		function getTAttach(code) {
			if (!code) return;

			return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
				return vm.tAttach = data;
			});
        }

        function getTitoliStudio() {
            if (vm.cmblist.titoliStudio.length > 0) return;

            return datacontext.arrTitoliStudio().then(function (data) {
                //console.info('getTitoliStudio', data);
                return vm.cmblist.titoliStudio = data;
            });
        }

        

        //************************
        //Func Delete

		function deleteAttach(item) {
			var msg = ' Allegato ' + item.Name;
			bDialog.deleteDialog(msg).then(function () {
				return datacontext.attach_delete(item.Id).then(function (data) {
					if (data == "400") return logError('Attenzione: allegato non cancellabile! Contattare l\'Help-desk');
					if (data == "417") return bDialog.errorDialog('Attenzione: azione non permessa, perch\xE8 entit\xE0 bloccata in cascata da altri elementi. ');

					var index = vm.list.attach.indexOf(item)
					vm.list.attach.splice(index, 1);
					//vm.record.stat_numAttach = vm.record.stat_numAttach - 1;
				});
			});
		}

		

		//****************************************************
		// OPEN MODAL DIALOG
		//****************************************************
		function addModal() {
			
		};

        
		
		// ATTACH
		function addAttach() {
			var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name }
			var recSource = { Id: vm.record.Id, Name: vm.record.RagioneSociale}

			var modalInstance = modal.open({
				templateUrl: '/app/ATT/attach/modal/attachAdd.html',
                controller: 'attachAdd',
                backdrop: 'static',
				resolve: {
					tSource: function () {
						return [recTSource];
					},
					tSourceCode: function () {
						return vm.tSource.Code;
					},
					tSourceId: function () {
						return vm.tSource.Id;
					},
					source: function () {
						return [recSource];
					},
					sourceId: function () {
						return recSource.Id;
					},
					tAttach: function () {
						return null;
					},
					tAttachId: function () {
						return null;
					}
				}
			});

			modalInstance.result.then(function (returnItem) {
                if (returnItem == "417") return logError('Attenzione: entit\xE0 bloccata. ');
                if (returnItem == "401") return logError('Attenzione: azione non autorizzata. ');
                if (returnItem == "406") return logError('Attenzione: allegato non permesso. ');
                if ($.isNumeric(returnItem)) return logError('Attenzione: errore generico. ');

				logSuccess('Dato salvato con successo! ');
				getListAttach(vm.record.Id);
				//vm.record.stat_numAttach = vm.record.stat_numAttach + 1;
			}, function () {
				//log('Modal dismissed at: ' + new Date());
			});
		};

		

	    
            
	}
})();
